import * as yup from 'yup';

export const forgotPasswordFormSchema = yup
  .object({
    email: yup.string().email('Must be a valid email').required()
  })
  .required();
